































































import { Vue, Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { objectIsEmpty } from '~/utils/common.js';

import HomeAppCard from '~/components/cards/HomeAppCard.vue';
import MarkdownContainer from '~/components/partials/MarkdownContainer.vue';

@Component({
  middleware: [
    'noauth',
  ],
  components: { HomeAppCard, MarkdownContainer },
  computed: {
    ...mapState('website', [
      'content',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
  head () {
    const self: any = this;
    const description = self.content?.content.match(new RegExp('<p>' + "(.*)" + '</p>')) || '';
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.$t('website.aboutTitle')} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          property: 'og:title',
          content: `${self.$t('website.aboutTitle')} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://www.onpiste.com/img/corporate/about_banner.jpg',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}about`,
        },
      ],
    };
  },
  async fetch () {
    const self: any = this;
    await self.$store.dispatch('website/getPage', {
      type: 'ABOUT',
      lang: self.$store.state.lang.locale,
    });
  },
})
export default class About extends Vue {
  content: {content: string};
  locale: string;

  /* Computed skeleton handle */
  get contentIsEmpty () {
    return objectIsEmpty(this.content);
  }
}
